module.exports = {
      id: "flex-credit-bonaire-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#flex-credit-bonaire",
      toString: function () {
        return this.url;
      }
    }